export const EmptyStateMessage = {
  CLICK_SEARCH: 'Click Search to view programs',
  NO_RESULTS: 'No results',
  PROGRAM_CHANGE_NOT_ALLOWED: 'Pricing is unavailable for this loan.',
};

export const BestPricingNoticeMessage = {
  WITH_FILTER_PANEL:
    'No programs are priced between par and a 0.5 point credit. Select an investor to see all available rates.',
  WITHOUT_FILTER_PANEL: 'No programs are priced between par and a 0.5 point credit.',
};

export const ExpiredPriceWarningMessage =
  "This price has expired and can't be locked until the loan is repriced.";
